import { call, put, takeEvery } from "redux-saga/effects"

// Crypto Redux States
import { GET_BULK_DELIVERY_LIST, GET_BULK_LIST, GET_BULK_LIST_FAIL, GET_BULK_LIST_SUCCESS, GET_BULK_SCHEDULE, SEND_BULK_SMS, SEND_QUICK_SMS } from "./actionTypes"

import {
  getBulkLists,
  getBulkListsFail,
  getBulkListsSuccess,
  getBulkDeliverySuccess,
  getBulkDeliveryFail,
  sendBulkSmsFail,
  sendBulkSmsSuccess,
  sendQuickSmsFail,
  sendQuickSmsSuccess,
  getBulkScheduleSuccess,
  getBulkScheduleFail,
  // getUserProfileSuccess,
  // getUserProfileFail,
  // addUserFail,
  // addUserSuccess,
  // updateUserSuccess,
  // updateUserFail,
  // deleteUserSuccess,
  // deleteUserFail,
} from "./actions"

//Include Both Helper File with needed methods
import { getBulkDeliveryData, getBulkListData, getBulkScheduleDetail, sendBulk, sendQuick } from "../../helpers/bulk_list_helper"

// toast
import { toast } from "react-toastify";
// import 'react-toastify/dist/ReactToastify.css';

function* fetchBulkLists({payload}) {
  try {
    const response = yield call(getBulkListData, payload);
    yield put(getBulkListsSuccess(response))
  } catch (error) {
    yield put(getBulkListsFail(error))
  }
}

function* fetchBulkShceduleDetail({payload}) {
  try {
    const response = yield call(getBulkScheduleDetail, payload);
    yield put(getBulkScheduleSuccess(response))
  } catch (error) {
    yield put(getBulkScheduleFail(error))
  }
}

function* fetchBulkDelivery({payload}) {
  try {
    const response = yield call(getBulkDeliveryData, payload);
    yield put(getBulkDeliverySuccess(response))
  } catch (error) {
    yield put(getBulkDeliveryFail(error))
  }
}

function* sendBulkSms(data) {
  try {
    const response = yield call(sendBulk, data.payload);
    yield put(sendBulkSmsSuccess(response))
  } catch (error) {
    yield put(sendBulkSmsFail(error))
  }
}

function* sendQuickSms(data) {
  try {
    const response = yield call(sendQuick, data.payload);
    yield put(sendQuickSmsSuccess(response))
  } catch (error) {
    yield put(sendQuickSmsFail(error))
  }
}

// function* fetchContactListDetail({payload}) {
//   try {
//     const response = yield call(getContactListDetailData, payload);
//     console.log(response);
//     yield put(getContactListDetailSuccess(response))
//   } catch (error) {
//     yield put(getContactListDetailFail(error))
//   }
// }

// function* fetchUserProfile() {
//   try {
//     const response = yield call(getUserProfile)
//     yield put(getUserProfileSuccess(response))
//   } catch (error) {
//     yield put(getUserProfileFail(error))
//   }
// }

// function* onUpdateUser({ payload: user }) {
//   try {
//     const response = yield call(updateUser, user)
//     yield put(updateUserSuccess(response))
//     toast.success("Contact Updated Successfully", { autoClose: 2000 });
//   } catch (error) {
//     yield put(updateUserFail(error))
//     toast.error("Contact Updated Failed", { autoClose: 2000 });
//   }
// }

// function* onDeleteUser({ payload: user }) {
//   try {
//     const response = yield call(deleteUser, user)
//     yield put(deleteUserSuccess(response))
//     toast.success("Contact Deleted Successfully", { autoClose: 2000 });
//   } catch (error) {
//     yield put(deleteUserFail(error))
//     toast.error("Contact Deleted Failed", { autoClose: 2000 });
//   }
// }

// function* onAddNewUser({ payload: user }) {

//   try {
//     const response = yield call(addNewUser, user)
//     yield put(addUserSuccess(response))
//     toast.success("Contact Added Successfully", { autoClose: 2000 });
//   } catch (error) {
//     yield put(addUserFail(error))
//     toast.error("Contact Added Failed", { autoClose: 2000 });
//   }
// }

function* bulkListsSaga() {
  yield takeEvery(GET_BULK_LIST, fetchBulkLists)
  yield takeEvery(GET_BULK_SCHEDULE, fetchBulkShceduleDetail)
  yield takeEvery(GET_BULK_DELIVERY_LIST, fetchBulkDelivery)
  yield takeEvery(SEND_BULK_SMS, sendBulkSms)
  yield takeEvery(SEND_QUICK_SMS, sendQuickSms)
  // yield takeEvery(GET_USER_PROFILE, fetchUserProfile)
  // yield takeEvery(ADD_NEW_USER, onAddNewUser)
  // yield takeEvery(UPDATE_USER, onUpdateUser)
  // yield takeEvery(DELETE_USER, onDeleteUser)
}

export default bulkListsSaga;
